export default {"src":"/_next/static/media/minus-ico.b5839f6c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};